// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  background: rgba(21, 20, 29, 0.6);
  backdrop-filter: saturate(140%) blur(10px);
  -webkit-backdrop-filter: saturate(140%) blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  font-size: 18px;
  z-index: 5;
   left: 0; 
   right: 0;
  width: 100%;
  height: 80px;
  margin: 0 auto;
  padding: 2%;
  display: flex;
  max-width: 1400px;
  justify-content: center;
  align-items: center;
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  padding: 0 20px;
}

.navbar-logo img {
  width: 130px;
}

.nav-menu {
  display: flex;
  list-style: none;
  text-align: center;
  width: auto;
  justify-content: flex-end;
}

.nav-item {
  display: flex;
  align-items: center;
  height: 80px;
  justify-self: flex-end;
}

.navbar_line {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-links {
  color: #fff;
  text-decoration: none;
  padding: 0 0.5rem;
}

.nav-links {
  position: relative;
}

.nav-links::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #ff6b35, #fb8500);
  transition: width 0.25s ease;
}

.nav-links:hover::after {
  width: 100%;
}

.nav-links.nav-links-last {
  margin-right: -16px;
  padding-right: 0;
  text-align: end;
}

.nav-menu li {
  padding: 1rem;
}

.hamburger {
  display: none;
  padding: 1rem;
}

.mobile-menu {
  display: none;
}

.fa-bars {
  color: #fff;
}

.menu-icon {
  display: none;
}

@media screen and (max-width: 767.98px) {
  .navbar {
    position: fixed;
    top: 0;
    z-index: 5;
    justify-content: center;
    align-items: center;
    margin: 0;
  }

  .navbar-container {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .navbar-logo img {
    justify-content: center;
    align-items: center;
    margin: 0;
    height: auto;
    top: 0;
  }

  .nav-menu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 80px;
    left: -100%;
    width: 100%;
    height: calc(100vh - 250px);
    background: rgba(21, 20, 29, 0.8);
    backdrop-filter: blur(8px);
    transition: all 0.5s ease;
    z-index: 1;
    font-size: 14px;
  }

  .nav-menu.active {
    left: 0;
  }

  .menu-icon {
    display: block;
    font-size: 1.6rem;
    cursor: pointer;
    color: #f4f4f4;
  }

  .nav-links {
    text-align: center;
    padding: 1rem;
    width: 100%;
  }

  .nav-item {
    width: 100%;
  }

  .nav-menu li {
    padding: 2.5rem 0; 
  }

  .nav-links.nav-links-last {
    margin-right: 0;
    padding-right: 0;
    padding-left: 16px;
    text-align: center;
  }

  .logo {
    margin: 0;
  }

  .fa-times {
    color: #fff;
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,iCAAiC;EACjC,0CAA0C;EAC1C,kDAAkD;EAClD,kDAAkD;EAClD,2CAA2C;EAC3C,eAAe;EACf,UAAU;GACT,OAAO;GACP,QAAQ;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,MAAM;EACR;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,iCAAiC;IACjC,0BAA0B;IAC1B,yBAAyB;IACzB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  background: rgba(21, 20, 29, 0.6);\n  backdrop-filter: saturate(140%) blur(10px);\n  -webkit-backdrop-filter: saturate(140%) blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  font-size: 18px;\n  z-index: 5;\n   left: 0; \n   right: 0;\n  width: 100%;\n  height: 80px;\n  margin: 0 auto;\n  padding: 2%;\n  display: flex;\n  max-width: 1400px;\n  justify-content: center;\n  align-items: center;\n}\n\n.navbar-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 80px;\n  width: 100%;\n  padding: 0 20px;\n}\n\n.navbar-logo img {\n  width: 130px;\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  text-align: center;\n  width: auto;\n  justify-content: flex-end;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  height: 80px;\n  justify-self: flex-end;\n}\n\n.navbar_line {\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-links {\n  color: #fff;\n  text-decoration: none;\n  padding: 0 0.5rem;\n}\n\n.nav-links {\n  position: relative;\n}\n\n.nav-links::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -8px;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #ff6b35, #fb8500);\n  transition: width 0.25s ease;\n}\n\n.nav-links:hover::after {\n  width: 100%;\n}\n\n.nav-links.nav-links-last {\n  margin-right: -16px;\n  padding-right: 0;\n  text-align: end;\n}\n\n.nav-menu li {\n  padding: 1rem;\n}\n\n.hamburger {\n  display: none;\n  padding: 1rem;\n}\n\n.mobile-menu {\n  display: none;\n}\n\n.fa-bars {\n  color: #fff;\n}\n\n.menu-icon {\n  display: none;\n}\n\n@media screen and (max-width: 767.98px) {\n  .navbar {\n    position: fixed;\n    top: 0;\n    z-index: 5;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n  }\n\n  .navbar-container {\n    padding: 0 20px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .navbar-logo img {\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    height: auto;\n    top: 0;\n  }\n\n  .nav-menu {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 80px;\n    left: -100%;\n    width: 100%;\n    height: calc(100vh - 250px);\n    background: rgba(21, 20, 29, 0.8);\n    backdrop-filter: blur(8px);\n    transition: all 0.5s ease;\n    z-index: 1;\n    font-size: 14px;\n  }\n\n  .nav-menu.active {\n    left: 0;\n  }\n\n  .menu-icon {\n    display: block;\n    font-size: 1.6rem;\n    cursor: pointer;\n    color: #f4f4f4;\n  }\n\n  .nav-links {\n    text-align: center;\n    padding: 1rem;\n    width: 100%;\n  }\n\n  .nav-item {\n    width: 100%;\n  }\n\n  .nav-menu li {\n    padding: 2.5rem 0; \n  }\n\n  .nav-links.nav-links-last {\n    margin-right: 0;\n    padding-right: 0;\n    padding-left: 16px;\n    text-align: center;\n  }\n\n  .logo {\n    margin: 0;\n  }\n\n  .fa-times {\n    color: #fff;\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
